import type { UiModes } from '../../services/commonCheckout/types/UiModes';

import { uiModeToRouteMap } from './uiModeToRouteMap';

export const mapUiModesToRoutes = (uiModes: UiModes[]) => {
  return uiModes.map((uiMode) => uiModeToRouteMap[uiMode]);
};
